/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TranslationsStrictHttpResponse } from '../../translations-strict-http-response';
import { TranslationsRequestBuilder } from '../../translations-request-builder';

import { TranslationsTranslateTextsRequestDto } from '../../models/translations-translate-texts-request-dto';
import { TranslationsTranslateTextsResponseDto } from '../../models/translations-translate-texts-response-dto';

export interface TextsControllerTranslateTexts$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: TranslationsTranslateTextsRequestDto
}

export function textsControllerTranslateTexts(http: HttpClient, rootUrl: string, params: TextsControllerTranslateTexts$Params, context?: HttpContext): Observable<TranslationsStrictHttpResponse<TranslationsTranslateTextsResponseDto>> {
  const rb = new TranslationsRequestBuilder(rootUrl, textsControllerTranslateTexts.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as TranslationsStrictHttpResponse<TranslationsTranslateTextsResponseDto>;
    })
  );
}

textsControllerTranslateTexts.PATH = '/o2-translations/texts/{tenant}';
